import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode } from "vue";
const _hoisted_1 = { class: "w-full py-12 overflow-hidden opacity-30 dark:opacity-20 select-none pointer-events-none border-y border-black/5 dark:border-white/5" };
const _hoisted_2 = { class: "flex whitespace-nowrap marquee-container" };
import { computed } from 'vue';
import { useLanguage } from '../composables/useLanguage';
import { CONTENT } from '../constants';
export default /*@__PURE__*/ _defineComponent({
    __name: 'Marquee',
    setup(__props) {
        const { language } = useLanguage();
        const marqueeText = computed(() => CONTENT[language.value].marquee);
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(4, (i) => {
                        return _createElementVNode("h2", {
                            key: i,
                            class: "text-6xl md:text-9xl font-black uppercase text-outline-black dark:text-outline-white tracking-tighter mx-8"
                        }, _toDisplayString(marqueeText.value), 1 /* TEXT */);
                    }), 64 /* STABLE_FRAGMENT */))
                ])
            ]));
        };
    }
});
